import { render, staticRenderFns } from "./DailyTaskDetailDialog.vue?vue&type=template&id=06b66c74&scoped=true&"
import script from "./DailyTaskDetailDialog.vue?vue&type=script&lang=js&"
export * from "./DailyTaskDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./DailyTaskDetailDialog.vue?vue&type=style&index=0&id=06b66c74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b66c74",
  null
  
)

export default component.exports